import { LoadingButton } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Avatar, CardHeader, Grid, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import { navigate } from "@reach/router";
import { formatLocaleCurrency } from "country-currency-map";
import PropTypes from "prop-types";
import * as React from "react";
import NumberFormat from "react-number-format";
import {
  addNotification,
  addTransfer,
  getuserDataAdmin,
  getuserDataBalanceAdmin,
  sendMessage,
  updateUserBalance,
} from "../../../config/services";
import CustomizedSnackbars from "../../components/snackbar";
import { db } from "../../../config/firebaseinit";
import { collection, doc, setDoc, Timestamp } from "firebase/firestore";
import { docData } from "rxfire/firestore";

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
});

NumberFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const generateAcnumber = Math.floor(Math.random() * 100000000000);

const current_timestamp = Timestamp.fromDate(new Date());

export default function CreditUser({ id }) {
  const type = "savings"; // or overdraft if changes are reqired later

  const [values, setValues] = React.useState({
    type: type,
    amount: "0",
    mode: "Domestic",
    // sendername: `${user.firstName} ${user.lastName}`,
    // accountnumber: generateAcnumber,
    date: "",
    transaction_type: "Credit",
  });

  const [user, setUser] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    image: "http//image.com",
    accountnumber: "",
  });

  const [currentbalance, setCurrentbalance] = React.useState(0);
  const [accountnumber, setAccountnumber] = React.useState("");
  const [errormessage, setErrorMeesage] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  React.useEffect(() => {
    const subscribeUserDtaAdmin = getuserDataAdmin(id).subscribe((userData) => {
      setUser(userData);
      console.log(userData);
    });

    const subscribeUserbalance = getuserDataBalanceAdmin(id, type).subscribe(
      (data) => {
        setCurrentbalance(data.balance);
        console.log(data);
      }
    );
    const accountQuery = doc(db, "users", `${id}`, "account", type);
    const subsuserAccount = docData(accountQuery).subscribe((data) => {
      setAccountnumber(data.accountnumber);
    });

    return () => {
      subscribeUserbalance.unsubscribe();
      subscribeUserDtaAdmin.unsubscribe();
      subsuserAccount.unsubscribe();
    };
  }, []);

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const changeDate = (e) => {
    var splittext = e.target.value.split("T");
    console.log(`${splittext[0]} ${splittext[1]}`);
    setValues({
      ...values,
      date: `${splittext[0]} ${splittext[1]}`,
    });
  };

  const submitCredit = (e) => {
    e.preventDefault();

    setLoading(true);
    //first add the transaction for user
    const docRef = doc(collection(db, "users", id, "transactions"));
    setDoc(docRef, {
      ...values,
      fullname: `${user.firstName} ${user.lastName}`,
      transaction_type: values.transaction_type,
      accountnumber: accountnumber,
      main: false,
      pending: false,
      timestamp: current_timestamp,
    }).then(() => {
      //second update balance
      const balance = currentbalance + parseInt(values.amount);
      updateUserBalance(id, type, balance).then(() => {
        addNotification(
          id,
          `Credit: ${formatLocaleCurrency(values.amount, "USD")}`,
          `your have recieved a deposit of ${formatLocaleCurrency(
            values.amount,
            "USD"
          )}.`
        ).then(() => {
          sendMessage(
            `Your account was credited <br/><br/>
            Amount: ${formatLocaleCurrency(balance, "USD")}  <br />
            `,
            // Sender: ${values.sendername}
            "Credit - Bitmax",
            user.email,
            `${user.firstName} ${user.lastName}`
          )
            .then((result) => {
              console.log(result);
              setLoading(false);
              navigate("/manager/reciept", {
                state: {
                  fullname: `${user.firstName} ${user.lastName}`,
                  mode: values.mode,
                  transaction_type: values.transaction_type,
                  amount: values.amount,
                  accountnumber: accountnumber,
                  date: values.date,
                  uid: docRef.id,
                },
              });
              // setOpenSnackbar(true);
            })
            .catch((error) => {
              console.log("error", error);
              setLoading(false);
            });
        });
      });
    });
  };

  return (
    <>
      <CustomizedSnackbars
        openSnackbar={openSnackbar}
        handleCloseSnackbar={handleCloseSnackbar}
        severity="success"
        message={"Success account credited  👍"}
      />
      <form onSubmit={submitCredit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <CardHeader
              title={`${user.firstName} ${user.lastName}`}
              subheader={user.email}
              avatar={
                <Avatar
                  sx={{ bgcolor: "#1A4DBE", width: 56, height: 56 }}
                  alt="Remy Sharp"
                  src={user.image}
                />
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              id="outlined-savings"
              label="Amount"
              variant="outlined"
              name="amount"
              value={values.amount}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              required
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              focused
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <TextField
                fullWidth
                id="datetime-local"
                label="Date"
                type="datetime-local"
                defaultValue={values.date}
                onChange={changeDate}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} md={12}>
            <LoadingButton
              loading={loading}
              fullWidth
              size="large"
              variant="contained"
              disableElevation
              type="submit"
            >
              Submit
            </LoadingButton>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography>Remaining balance</Typography>
            <Typography variant="h5">
              {formatLocaleCurrency(currentbalance, "USD")}
            </Typography>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
